import React, { forwardRef, useMemo } from 'react';
import { Select as SelectBase, SelectProps } from "@chakra-ui/core";

import { Container, Label, Error } from './styles';

interface Props extends SelectProps {
    label?: string;
    borderColor?: string;
    error?: any;
    name: string;
}

const Select: React.FC<Props> = forwardRef(({ children, name, label, borderColor, error, ...props }, ref) => {
  const isError = useMemo(() => {
    return !!error && !!error[name];
  }, [error, name]);

  return (
    <Container>
        <Label color={isError ? '#f00' : "#01509C"}>{label}</Label>
        <SelectBase {...props} name={name} borderRadius="6px" ref={ref} borderColor={isError ? '#f00' : "#01509C"} height="36px" fontSize={14}>
            {children}
        </SelectBase>
        {!!error && !!error[name] && <Error>{error[name].message}</Error>}
    </Container>
  );
});

export default Select;